// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cop5","left":"styles_left__13FKw"};